import http from "../utils/http";

export default {
  async signup(
    email,
    password,
    terms_accepted, 
    newsletter_optin,
    url_params = {},
  ) {
    const data = {
      email,
      password,
      terms_accepted,
      newsletter_optin,
      url_params,
    };
    // console.log('DAta: ', data)
    return http({
      url: "/auth/local/signup",
      method: "post",
      data
    });
  },
};
